import { Component, OnInit } from '@angular/core';
import { Output, EventEmitter, Input } from '@angular/core';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LanguageConstants } from 'src/app/shared-components/constant';

@Component({
  standalone: false,
  selector: 'app-errorpopup',
  templateUrl: './errorpopup.component.html',
  styleUrls: ['./errorpopup.component.css']
})
export class ErrorpopupComponent implements OnInit {
  @Input() errorPopUpModel: ErrorPopUpModel = new ErrorPopUpModel();
  @Output() selecteddisplayevent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  currLangTranslation: any;
  langCode: string;

  constructor(private translateService: TranslateService) { }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];

    if (!this.errorPopUpModel.headerTitle) {
      this.errorPopUpModel.headerTitle = this.currLangTranslation.labels.error;
    }

    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });
  }

  ClosePopup() {
    this.errorPopUpModel.confirmIsDisplay = false;
    this.closeEvent.emit(this.errorPopUpModel.confirmIsDisplay);
  }

  isArray(obj: any) {
    return Array.isArray(obj);
  }
}
